import {rawRenderingLib} from '@wallaby-ui/core';

import documentLinkRenderer from './document_link_renderer';
import styles from 'src/js/common/components/formatters/ReportLinkFormatter.less';
import baseReportLinkFormatterParams from 'src/js/lib/raw_rendering/base_report_link_formatter_params';

/**
 * Returns raw DOM element version of ReportLinkFormatter component.
 * @param params
 * @param services
 * @returns {Element}
 */
export default function reportLinkFormatter(params, services = {}) {
  const {filterName, label, link, route, searchParams, titleText} =
    baseReportLinkFormatterParams(params, services);

  const divElem = document.createElement('div');
  divElem.className = styles.dlReportLink;
  const textElem = rawRenderingLib.plainTextOrHtmlRenderer({
    showHtml: true,
    text: label,
  });
  if (filterName && route && link && searchParams) {
    const documentLinkElem = documentLinkRenderer(
      {
        documentDetailRoute: route,
        titleText,
        searchParams,
        suppressPadding: true,
        children: textElem,
      },
      services
    );
    rawRenderingLib.RawRenderingService.appendChildNodeOrHtml(
      divElem,
      documentLinkElem
    );
  } else {
    rawRenderingLib.RawRenderingService.appendChildNodeOrHtml(
      divElem,
      textElem
    );
  }

  return divElem;
}
